import { useMemo } from 'react';

import Icon from 'components/shared/Icon';
import Close from 'components/shared/Icon/icons/Close';
import i18n from 'i18n';
import { ITINERARIES_ITEM_TYPE_TO_LABEL_MAP } from 'utils/itineraries/map';

import { Content, type ContentProps } from './Content';
import s from './index.module.css';

type ShareProps = ContentProps & {
  builder: boolean;
  landingShareUrl: string;
};

function Share(props: ShareProps) {
  const {
    itinerariesItemType,
    closeModal,
    landingShareUrl,
    itemId,
    builder,
    showPermissions,
    manageHideCosts,
    hideHideCosts,
  } = props;

  const title = useMemo(() => {
    if (builder) {
      return `Share ${ITINERARIES_ITEM_TYPE_TO_LABEL_MAP[itinerariesItemType]}`;
    }
    return i18n.t('proposal_content.guest_portal.share.title');
  }, [builder]);

  return (
    <div className={s.container}>
      <div className={s.header}>
        <h4 className={s.title}>{title}</h4>
        <button type="button" className={s.close} tabIndex={0} onClick={closeModal}>
          <Icon component={Close} className={s.closeIcon} width="3rem" height="3rem" strokeWidth={1.5} />
        </button>
      </div>
      <div className={s.content}>
        <Content
          builder={builder}
          itinerariesItemType={itinerariesItemType}
          landingShareUrl={landingShareUrl}
          itemId={itemId}
          closeModal={closeModal}
          showPermissions={showPermissions}
          manageHideCosts={manageHideCosts}
          hideHideCosts={hideHideCosts}
        />
      </div>
    </div>
  );
}

export default Share;
